import React, { useState, useEffect, useRef } from "react";
import styles from "./styles.module.scss";
import { useDispatch } from "react-redux";
import { getGoalList } from "../../modules/actions/PlanActions";

// Icons
import { ReactComponent as Search } from "assets/svg/Search.svg";
import { ReactComponent as GoalLogo } from "assets/svg/logoGoal.svg";

import { getPath } from "../AppSwitcher";

const GoalSearch = ({
  allGoalList,
  goalRef,
  onwer,
  setSelectedGoal,
  setGoalName,
  setIsGoalModel,
  isGoalSelect,
  setIsGoalSelect,
  selectedGoal,
  isHeader = false,
  isProjectDetail = false,
  outsideClick = false,
  isCustomHeight = null,
  isWizard = false,
  isGoalSelectBottom = false,
}) => {
  const { gmURL } = getPath();
  const dispatch = useDispatch();
  const [searchGoal, setSearchGoal] = useState("");
  const [loading, setLoading] = useState(false);
  const listContainerRef = useRef(null);
  const offsetRef = useRef(0); // Use ref instead of state for offset

  const filterGoalList = allGoalList?.filter((goal) =>
    goal?.goal_name.toLowerCase().includes(searchGoal.toLowerCase())
  );

  // Initial load of goals when component mounts
  useEffect(() => {
    if (isGoalSelect && onwer) {
      // Initial API call with l=50, o=0
      offsetRef.current = 0; // Reset offset on initial load
      dispatch(getGoalList({ l: 50, o: 0, is_loading: false }));
    }
  }, [isGoalSelect, dispatch, onwer]);

  // State to track if there are more goals to load
  const [hasMoreGoals, setHasMoreGoals] = useState(true);

  // Effect to update hasMoreGoals when allGoalList changes
  const previousGoalCountRef = useRef(0); // Ref to store the previous count of goals
  useEffect(() => {
    // Check if we received an empty response from the API
    if (offsetRef.current > 0) {
      // Compare the previous count of goals with the current count
      if (previousGoalCountRef.current === (filterGoalList?.length || 0)) {
        setHasMoreGoals(false);
      }
      // Update the previous count to the current count
      previousGoalCountRef.current = filterGoalList?.length || 0;
    }
  }, [allGoalList, filterGoalList]);

  // Handle scroll event to load more goals
  const handleScroll = (e) => {
    if (!listContainerRef.current || loading || !hasMoreGoals) return;

    const { scrollTop, scrollHeight, clientHeight } = e.target;

    // Check if scrolled to bottom (with a small threshold)
    if (scrollHeight - scrollTop <= clientHeight + 10) {
      setLoading(true);
      // Increment offset by 50 each time
      offsetRef.current = offsetRef.current + 50;
      // Dispatch action to load more goals with updated offset
      // l=50, o=50, then o=100, then o=150, etc.
      dispatch(getGoalList({ l: 50, o: offsetRef.current, is_loading: false }));
      // Reset loading state after a short delay
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    if (outsideClick) {
      const handleClickOutside = (event) => {
        if (goalRef.current && !goalRef.current.contains(event.target)) {
          setIsGoalSelect(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [setIsGoalSelect]);

  return (
    <>
    {/* Placeholder div for bottom goal selection UI */}  
      {isGoalSelectBottom && (
        <div className={styles.goal_select_lists_bottom}></div>
      )}
      {onwer && allGoalList?.length > 0 ? (
        <div
          className={styles.goal_select_lists}
          ref={(el) => {
            goalRef.current = el;
            listContainerRef.current = el;
          }}
          style={{
            visibility: isGoalSelect ? "visible" : "hidden",
            opacity: isGoalSelect ? 1 : 0,
            top: isHeader ? "70px" : "45px",
            left: isHeader || isProjectDetail ? "0px" : "10px",
            width: isHeader ? "97%" : "100%",
            height: isCustomHeight ? isCustomHeight : "max-content",
            maxHeight: "300px",
            overflowY: "auto",
          }}
          onScroll={handleScroll}
        >
          <div className={styles.goal_search}>
            <input
              placeholder="Search goal"
              value={searchGoal}
              onChange={(e) => setSearchGoal(e.target.value)}
            />
            <Search />
          </div>

          {filterGoalList?.length > 0 ? (
            filterGoalList?.map((goal, index) => {
              const color = goal?.color;

              return (
                <div
                  className={styles.goal_select_list}
                  key={index}
                  style={{
                    borderLeftColor: color || "#A3A3A3",
                    backgroundColor:
                      selectedGoal?.id === goal?.id ? "#f8f8f8" : "#fff",
                  }}
                  onClick={() => {
                    setSelectedGoal && setSelectedGoal(goal);
                    setGoalName && setGoalName(goal?.goal_name);
                    setIsGoalModel && setIsGoalModel(true);
                    setIsGoalSelect && setIsGoalSelect(false);
                  }}
                >
                  <h3>{goal?.goal_name || "No name"}</h3>
                </div>
              );
            })
          ) : (
            <div className={styles.noGoal}>
              <h3>No goal found</h3>
            </div>
          )}

          {loading && (
            <div
              className={styles.loadingMore}
              style={{ textAlign: "center", padding: "10px" }}
            >
              <p style={{ fontSize: "10px" }}>Loading more goals...</p>
            </div>
          )}

          {!hasMoreGoals && offsetRef.current > 0 && (
            <div
              className={styles.noMoreGoals}
              style={{ textAlign: "center", padding: "10px" }}
            >
              <p style={{ fontSize: "10px" }}>No more goals</p>
            </div>
          )}

          <div className={styles.createGaol}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                window.open(`https://${gmURL}`, "_blank");
              }}
            >
              Create Goal
            </button>
          </div>
        </div>
      ) : (
        onwer && (
          <div
            ref={goalRef}
            className={styles.goal_select}
            style={{
              visibility: isGoalSelect ? "visible" : "hidden",
              opacity: isGoalSelect ? 1 : 0,
              top: isHeader ? "70px" : "45px",
              left: isHeader ? "0px" : isWizard ? "0px" : "10px",
              width: isHeader ? "97%" : "100%",
              height: isCustomHeight
                ? isCustomHeight
                : isHeader
                ? "250px"
                : "200px",
            }}
          >
            <GoalLogo />

            <h3>You don’t have any goal created yet.</h3>

            <button
              onClick={() => {
                window.open(`https://${gmURL}`, "_blank");
              }}
            >
              Go to Goal Manager
            </button>

            <span onClick={() => setIsGoalSelect(false)}>Not Now</span>
          </div>
        )
      )}
    </>
  );
};

export default GoalSearch;
